import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  thumbnail: {
    display: "none",
    width: 140,
    height: 210,
    backgroundColor: "#efefef",
    margin: theme.spacing(0.5),
  },
  showThumbnail: {
    display: "block",
  },
  missingThumbnail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imageContainer: {
    marginLeft: theme.spacing(0.25),
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  variantContainer: {
    width: 130,
    maxHeight: 210,
    overflow: "auto",
    scrollbarWidth: "thin",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(0.5),
  },
  variantText: {
    fontSize: "0.9em",
  },
  standardContainer: {
    backgroundColor: "#ffffff",
  },
  previewContainer: {
    backgroundColor: "#00c4c4",
  },
  previewOverlay: {
    position: "absolute",
    top: "5%",
    left: "50%",
    transform: "translate(-50%, -30%)",
  },
  expressContainer: {
    backgroundColor: "#BD5D00",
  },
  expressOverlay: {
    position: "absolute",
    top: "5%",
    left: "50%",
    transform: "translate(-50%, -30%)",
  },
  noVariantContainer: {
    marginLeft: theme.spacing(1.5),
  },
}));
